export const SET_USERINFO = 'SET_USERINFO'

export const SET_USERID = 'SET_USERID'

export const SET_OPENID = 'SET_OPENID'

export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS'

export const SET_TOKEN = 'SET_TOKEN'

export const SEND_DICTIONARY = 'SEND_DICTIONARY'

export const SET_SHOWLEFTSTATUS = 'SET_SHOWLEFTSTATUS'


// WEBPACK FOOTER //
// ./src/store/mutationTypes.js